import Image from 'next/image';
import Link from 'next/link';
import Step2 from "../../components/Cart/Icons/Step2";
import Step1 from "../../components/Cart/Icons/Step1";
import Step3 from "../../components/Cart/Icons/Step3";
import { useContext, useEffect, useMemo, useState } from "react";
import PaymentContext from "../../store/PaymentContext";
import { useRouter } from "next/router";
import { PaymentConst } from "../../utils/payment";

const HeaderPayment = ({ }: any) => {
    const { isMobile } = useContext(PaymentContext);
    const router = useRouter();
    const { currentStep, setCurrentStep }: any = useContext(PaymentContext);
    const color = PaymentConst.Color.primary;
    const black = 'white';

    function changeStep(router: any) {

        if (router.pathname === '/carts') {
            return 1;
        }

        if (router.pathname === '/checkout') {
            return 2;
        }

        if (router.pathname === '/order-success') {
            return 3;
        }

        return 1;
    }

    const step = useMemo(() => {
        if (router.pathname === '/carts') {
            return 1;
        }

        if (router.pathname === '/checkout') {
            return 2;
        }

        if (router.pathname === '/order-success') {
            return 3;
        }

        return 1;
    }, [router])

    useEffect(() => {
        setCurrentStep(changeStep(router));
    }, [router.pathname])


    return (
        <div className={`header px-2 md:rounded-tl-lg md:rounded-tr-lg ${isMobile && step == 1 ? 'fixed w-full z-50' : ''}`}>
            <div className='header-component cart__header-component-content m-auto'>
                <div className="flex flex-row items-center justify-between h-full flex-1">
                    <div className="flex items-center">
                        {
                            step !== 3 && (
                                <div
                                    className={'cursor-pointer'}
                                    onClick={() => {
                                        // if (step === 1) {
                                        //     router.push('/')
                                        // } else {
                                        //     router.push('/carts')
                                        // }
                                        router.back();
                                    }}
                                >
                                    <svg width={isMobile ? 24 : 32} height={isMobile ? 24 : 32} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <mask id="mask0_6017_182825" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x={12} y={4} width={20} height={36}>
                                            <path d="M31.1701 5.47258C30.2717 4.57424 28.8234 4.57424 27.9251 5.47258L12.6901 20.7076C11.9751 21.4226 11.9751 22.5776 12.6901 23.2926L27.9251 38.5276C28.8234 39.4259 30.2717 39.4259 31.1701 38.5276C32.0684 37.6292 32.0684 36.1809 31.1701 35.2826L17.8967 21.9909L31.1884 8.69924C32.0684 7.81925 32.0684 6.35258 31.1701 5.47258Z" fill="black" />
                                        </mask>
                                        <g mask="url(#mask0_6017_182825)">
                                            <rect width={44} height={44} fill="#FFFFFF" />
                                        </g>
                                    </svg>
                                </div>
                            )
                        }
                        <Link
                            //href={"/"} 
                            href={{ pathname: '/', query: { group: [] } }}
                            className="header-component-content--logo cart__header-component-content--logo flex items-center gap-2 w-[112px] h-[36px] lg:w-[166px] lg:h-[34px] relative overflow-hidden xl:w-[197px] xl:h-[50px]">
                            <Image
                                className="logo"
                                src="/asset/icon/logo.webp"
                                alt="Logo shop"
                                title="Logo shop"
                                width={isMobile ? 98 : 197}
                                height={isMobile ? 28 : 50}
                            />
                        </Link>
                    </div>

                    <div className="flex items-center gap-2 justify-end text-white">
                        <Step1 currentStep={step} active={step === 1} color={step === 1 ? color : black} />
                        <Step2 currentStep={step} active={step === 2} color={step === 2 ? color : black} />
                        <Step3 currentStep={step} active={step === 3} color={step === 3 ? color : black} />
                    </div>
                </div>
            </div>

        </div>
    )
}

export default HeaderPayment;
